import $ from "jquery";

class SpiderChart {
    constructor($chart) {
        this.Options = {
            datasets: [
                {
                    backgroundColor: "rgba(220,220,220,0.6)",
                    borderColor: "rgba(220,220,220,1)",
                    pointHitRadius: 10,
                    radius: 0,
                    pointBackgroundColor: "rgba(220,220,220,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(220,220,220,1)"
                }
            ],
            chartOptions: {
                scale: {
                    display: true,
                    ticks: {
                        min: 0,
                        max: 10,
                        stepSize: 2,
                        fontColor: "#333",
                        display: false
                    }
                },
                tooltips: {
                    mode: 'nearest',
                    intersect: false
                },
                hover: {
                    mode: 'nearest',
                    intersect: false
                },
                legend: {
                    display: false
                },

                responsive: true
            }
        };

        var datasets = this.Options.datasets;
        datasets[0]['label'] = $chart.data('chartLabel');
        datasets[0]['data'] = $chart.data('chartData');

        var processedChart = new Chart($chart, {
            type: 'radar',
            data: {
                labels: $chart.data('chartLabels'),
                datasets: datasets
            },
            options: this.Options.chartOptions
        });

    }
}

export default SpiderChart;